import React from "react";

import {
	Box,
	Button,
	CircularProgress,
	Divider,
	Icon,
	Paper,
	Typography,
	useMediaQuery,
	useTheme,
} from "@mui/material";

interface ToolbarUserDetailProps {
	isLoading: boolean;
	isNew: boolean;

	canSave: boolean;
	canCreate: boolean;
	canResetPassword: boolean;

	onSave: () => void;
	onSaveAndClose: () => void;
	onResetPassword: () => void;
	onBack: () => void;
	onNew: () => void;
}

export const ToolbarUserDetail: React.FC<ToolbarUserDetailProps> = ({
	isLoading,
	isNew,
	canSave,
	canCreate,
	canResetPassword,
	onSave,
	onSaveAndClose,
	onResetPassword,
	onBack,
	onNew,
}) => {
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));
	const mdDown = useMediaQuery(theme.breakpoints.down("md"));

	const savingDisabled = isLoading || !canSave;
	const newDisabled = isLoading || !canCreate;
	const resetDisabled = isLoading || !canResetPassword;

	return (
		<Box component={Paper} display="flex" alignItems="center" gap={1} mx={1} px={2} py={1} elevation={0}>
			<Button
				color="primary"
				disableElevation
				variant="contained"
				onClick={onSave}
				disabled={savingDisabled}
				startIcon={isLoading ? <CircularProgress size={18} color="inherit" /> : <Icon>check</Icon>}
			>
				<Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
					Salvar
				</Typography>
			</Button>

			{!smDown && !mdDown && (
				<Button
					color="primary"
					disableElevation
					variant="outlined"
					onClick={onSaveAndClose}
					disabled={savingDisabled}
					startIcon={<Icon>file_download_done</Icon>}
				>
					<Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
						Salvar e fechar
					</Typography>
				</Button>
			)}

			{!isNew && !smDown && (
				<Button
					color="primary"
					disableElevation
					variant="outlined"
					onClick={onNew}
					disabled={newDisabled}
					startIcon={<Icon>add</Icon>}
				>
					<Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
						Novo
					</Typography>
				</Button>
			)}

			{!isNew && (
				<Button
					color="primary"
					disableElevation
					variant="outlined"
					onClick={onResetPassword}
					disabled={resetDisabled}
					startIcon={<Icon>lock_reset</Icon>}
				>
					<Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
						Reset senha
					</Typography>
				</Button>
			)}

			<Divider variant="middle" orientation="vertical" flexItem />

			<Button color="primary" disableElevation variant="outlined" onClick={onBack} startIcon={<Icon>reply</Icon>}>
				<Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
					Voltar
				</Typography>
			</Button>
		</Box>
	);
};
